// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-wrapper {
    max-width: 100%;
    overflow: scroll;
}

.specialTable table {
    table-layout: fixed;
    width: 100%;
    position: relative;
    border: 1px solid #ddd;
    border-collapse: collapse;
}

.specialTable td, th {
    white-space: nowrap;
    border: 1px solid #ddd;
    padding: 20px;
}

.specialBG {
    background-color: #eee;
}

.specialTable th {
    background-color: #eee;
}


.specialTable tbody tr td:first-of-type {
    background-color: #eee;
}


.nopadding {
    padding: 0 !important;
    margin: 0 !important;
}


.limit-width {
    /**border: 2px solid black;*/
    min-width: 100%;
    max-width: 100%;
    overflow-x: auto;
}

.font-small {
    font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/empty-state-table/empty-state-table.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;;AAGA;IACI,4BAA4B;IAC5B,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".table-wrapper {\n    max-width: 100%;\n    overflow: scroll;\n}\n\n.specialTable table {\n    table-layout: fixed;\n    width: 100%;\n    position: relative;\n    border: 1px solid #ddd;\n    border-collapse: collapse;\n}\n\n.specialTable td, th {\n    white-space: nowrap;\n    border: 1px solid #ddd;\n    padding: 20px;\n}\n\n.specialBG {\n    background-color: #eee;\n}\n\n.specialTable th {\n    background-color: #eee;\n}\n\n\n.specialTable tbody tr td:first-of-type {\n    background-color: #eee;\n}\n\n\n.nopadding {\n    padding: 0 !important;\n    margin: 0 !important;\n}\n\n\n.limit-width {\n    /**border: 2px solid black;*/\n    min-width: 100%;\n    max-width: 100%;\n    overflow-x: auto;\n}\n\n.font-small {\n    font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
